import imageCompression from 'browser-image-compression';
import { utilsApiSlice } from '../slices/utilsApiSlice';
import store from '../store';

export const compressAndUploadImage = async (files, fieldName = 'images') => {
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    };

    try {
        const formData = new FormData();

        const fileList = Array.isArray(files) ? files : [files];

        for (const file of fileList) {
            const compressed = await imageCompression(file, options);
            formData.append(fieldName, compressed, compressed.name);
        }

        return await store
            .dispatch(utilsApiSlice.endpoints.uploadImage.initiate(formData))
            .unwrap();
    } catch (error) {
        console.error('Compression or upload failed:', error);
        throw error;
    }
};
